module.exports = __webpack_public_path__ + "static/media/dp-1.0ec3bfc3.jpg";